module.exports = __webpack_public_path__ + "img/7.2c859306.jpg";